/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GridModeConfigDTO } from './GridModeConfigDTO';
import {
    GridModeConfigDTOFromJSON,
    GridModeConfigDTOFromJSONTyped,
    GridModeConfigDTOToJSON,
} from './GridModeConfigDTO';

/**
 * 
 * @export
 * @interface LayoutConfigDataDTO
 */
export interface LayoutConfigDataDTO {
    /**
     * 
     * @type {GridModeConfigDTO}
     * @memberof LayoutConfigDataDTO
     */
    gridMode: GridModeConfigDTO;
}

/**
 * Check if a given object implements the LayoutConfigDataDTO interface.
 */
export function instanceOfLayoutConfigDataDTO(value: object): value is LayoutConfigDataDTO {
    if (!('gridMode' in value) || value['gridMode'] === undefined) return false;
    return true;
}

export function LayoutConfigDataDTOFromJSON(json: any): LayoutConfigDataDTO {
    return LayoutConfigDataDTOFromJSONTyped(json, false);
}

export function LayoutConfigDataDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayoutConfigDataDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'gridMode': GridModeConfigDTOFromJSON(json['gridMode']),
    };
}

export function LayoutConfigDataDTOToJSON(value?: LayoutConfigDataDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'gridMode': GridModeConfigDTOToJSON(value['gridMode']),
    };
}

